export default __webpack_public_path__ + "static/media/receipt.12c13514.svg";